import React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { Projects } from "../../modules/_projects";

import RightActionArea from "../../components/ActionAreaRight";
import Button from "../../elements/Button";
import ModalBasic from "../../components/ModalBasic";
import NewProject from "./NewProject";
import ProjectDetails from "./ProjectDetails";
import { utils } from "../../modules/_utils";

import { TrashIcon } from "@heroicons/react/20/solid";
import DialogBox from "../../components/Dialog";
import ListTable from "./components/ListTable";
import PageHeader from "../../components/PageHeader";
import Tabs from "../component/Tabs";
import NewSolicitation from "./NewSolicitation";
import Input from "../../components/Input";
import { Switch } from "@headlessui/react";
import { _auth } from "../../modules/_auth";
import { get } from "immutable";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
export default function ProjectList(props) {
  const getLocalStorage = utils.getLocalStorage;
  const setLocalStorage = utils.setLocalStorage;
  const history = useHistory();
  const profile = _auth.getUserProfile();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newProjectModalOpen, setNewProjectModalOpen] = useState(false);
  const [newProjectStep, setNewProjectStep] = useState(1);
  const [newSolicitationModalOpen, setNewSolicitationModalOpen] =
    useState(false);
  const [newSolicitationData, setProjectForNewSolicitation] = useState(null);

  const [selectedProject, setSelectedProject] = useState({});
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [deletionEvent, setDeletionEvent] = useState(null);
  const [success, setSuccess] = useState(false);
  const [selectedProjectModalOpen, setSelectedProjectModalOpen] =
    useState(false);
  const [limit, setLimit] = useState(0);
  const [initialData, setInitialData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = React.useState("All");
  const [searchText, setSearchText] = useState("");
  const [sortOrder, setSortOrder] = useState("recent");
  const [onlyShowMyData, setOnlyShowMyData] = useState(
    getLocalStorage("onlyShowMyData")
      ? getLocalStorage("onlyShowMyData")
      : false
  );
  const fromModal = props.fromModal ? props.fromModal : false;

  useEffect(() => {
    let tabs = [
      {
        name: "All",
        href: "#",
        current: true,
      },
      {
        name: "Open",
        href: "#",
        current: true,
      },
      {
        name: "Closed",
        href: "#",
        current: true,
      },
    ];
    //if data has any isOwner false, add the "Shared with me" tab
    let hasShared =
      data && data.length > 0 && data.some((item) => item.isOwner == false);
    if (hasShared) {
      console.log("Shared with me tab");
      tabs.push({
        name: "Shared with me",
        href: "#",
        current: true,
      });
    }
    setTabs(tabs);
  }, [data]);

  useEffect(() => {
    (async () => {
      let list = await Projects.list("tenant", "project-list");

      if (list) {
        console.log("Got Project List", list);
        sortData(list, sortOrder);
        setData(list);
        setLimit(list.length > 2000 ? 2000 : list.length);
      } else {
        console.log("Got Project list but it is empty");
        setData([]);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    filterProjects();
  }, [data, selectedTab, onlyShowMyData, searchText, sortOrder]);

  const filterProjects = () => {
    let filtered = [...data];

    // 1. Filter by tab (status or "shared with me")
    if (selectedTab === "Shared with me") {
      filtered = filtered.filter((item) => item.isOwner === false);
    } else if (selectedTab !== "All") {
      filtered = filtered.filter((item) => item.status === selectedTab);
    }

    // 2. Filter by creator
    if (onlyShowMyData === true) {
      filtered = filtered.filter(
        (item) => item?.createdBy?._id === profile.user_id
      );
    }

    // 3. Filter by search text
    if (searchText && searchText.trim() !== "") {
      const lower = searchText.toLowerCase();
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(lower)
      );
    }

    // 4. Sort
    filtered = sortData(filtered, sortOrder);

    setFilteredData(filtered);
  };

  // useEffect(() => {
  //   console.log("Sort Order changed", sortOrder);
  //   let sortedData = sortData([...filteredData], sortOrder); // Create a new array reference
  //   console.log("Data has been sorted", sortedData);
  //   if (onlyShowMyData === true && Array.isArray(sortedData)) {
  //     sortedData = getMyBids(sortedData, "useEffect2");
  //   }
  //   setFilteredData(sortedData);
  // }, [sortOrder]);

  const sortData = (data, order) => {
    if (order === "recent") {
      return data
        .slice()
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    } else {
      return data.slice().sort((a, b) => a.name.localeCompare(b.name));
    }
  };

  // const sortData = (data, order) => {
  //   console.log("Sort Data", order);
  //   if (order == "recent") {
  //     return data.sort((a, b) => {
  //       return new Date(b.createdAt) - new Date(a.createdAt);
  //     });
  //   } else {
  //     return data.sort((a, b) => {
  //       return a.name.localeCompare(b.name);
  //     });
  //   }
  // };

  // useEffect(() => {
  //   (async () => {
  //     let list = await Projects.list("tenant", "project-list");

  //     if (list) {
  //       console.log("Got Project List", list);
  //       sortData(list, sortOrder);
  //       setData(list);
  //       if (onlyShowMyData === true && Array.isArray(list)) {
  //         let tmplist = getMyBids(list, "useEffect1");
  //         if (tmplist.length > 0) {
  //           list = tmplist;
  //         }
  //       }
  //       setFilteredData(list);
  //       setLimit(list.length > 2000 ? 2000 : list.length);
  //     } else {
  //       console.log("Got Project list but it is empty");
  //       setData([]);
  //     }
  //   })();
  // }, [props.data]);

  // useEffect(() => {
  //   console.log("Selected Tab", selectedTab);
  //   let filtered = [];
  //   if (selectedTab == "All") {
  //   } else if (selectedTab == "Shared with me") {
  //     filtered = data.filter((item) => item.isOwner == false);
  //     // setFilteredData(filtered);
  //     filtered = filtered;
  //   } else {
  //     filtered = data.filter((item) => item.status == selectedTab);
  //     // setFilteredData(filtered);
  //     filtered = filtered;
  //   }

  //   if (searchText && searchText.length > 0) {
  //     filtered = data.filter((item) =>
  //       item.name.toLowerCase().includes(searchText.toLowerCase())
  //     );
  //   }

  //   if (onlyShowMyData === true && Array.isArray(filtered)) {
  //     filtered = getMyBids(filtered, "useEffect3");
  //   }
  //   setFilteredData(filtered);
  // }, [selectedTab, onlyShowMyData]);

  // const getMyBids = (d, source) => {
  //   if (!d) {
  //     console.log("getMyBids no data", source);
  //     return null;
  //   }
  //   console.log("getMyBids", d, source);
  //   let filtered = null;
  //   try {
  //     filtered = [...d];
  //   } catch (e) {
  //     console.log(`getMyBids from ${source} using ${d}`, e);
  //   }

  //   let userId = profile.user_id;
  //   // console.log("getMyBids userId", source, userId, profile);

  //   filtered = d && d.filter((item) => item?.createdBy?._id == userId);
  //   return filtered;
  // };

  // useEffect(() => {
  //   console.log("Search Text", searchText);
  //   let pre_searched;
  //   if (selectedTab == "All") {
  //     if (onlyShowMyData === true) {
  //       pre_searched = getMyBids(data, "pre_searched useEffect4");
  //     } else {
  //       pre_searched = data;
  //     }
  //   } else {
  //     pre_searched = filteredData;
  //   }

  //   let dataToSearch = [...filteredData];
  //   // if (onlyShowMyData === true) {
  //   //   dataToSearch = getMyBids(pre_searched);
  //   //   if (dataToSearch.length == 0) {
  //   //     return;
  //   //   }
  //   // }

  //   if (searchText) {
  //     let filtered =
  //       dataToSearch.length > 0
  //         ? dataToSearch.filter((item) =>
  //             item.name.toLowerCase().includes(searchText.toLowerCase())
  //           )
  //         : dataToSearch.filter((item) =>
  //             item.name.toLowerCase().includes(searchText.toLowerCase())
  //           );
  //     setFilteredData(filtered);
  //   } else {
  //     setFilteredData(pre_searched);
  //   }
  // }, [searchText]);

  useEffect(() => {
    let newData = data && data.length > 0 ? data.slice(0, limit) : [];
    setInitialData(newData);
  }, [data]);

  const handleSetOnlyShowMyDate = (e) => {
    setOnlyShowMyData(e);
    setLocalStorage("onlyShowMyData", e);
  };

  const handleChangeSortOrder = () => {
    let order = sortOrder == "recent" ? "az" : "recent";
    setSortOrder(order);
  };

  const handleOpenProjectClick = (project) => {
    setSelectedProject(project);
    setSelectedProjectModalOpen(true);
  };

  const navigateToProject = (project) => {
    // alert("Navigate to project", JSON.stringify(project));
    const state = { project: project };
    history.push({
      pathname: "/projects/project-details/" + project._id,
      state: state,
    });
  };

  const handleOpenNewProjectModalClick = () => {
    setNewProjectStep(1);
    setNewProjectModalOpen(true);
  };

  const handleAfterCreateProject = (project) => {
    console.log("Project Created", project);
    //update data to include new project
    let oldData = data;
    let newData = [...oldData, project];
    setData(newData);
    setNewProjectStep(1);
    // setProjectForNewSolicitation(project);
  };
  const handleCreateNewSolicitation = (data) => {
    console.log("handleCreateNewSolicitation", data);
    setProjectForNewSolicitation(data);
    setNewSolicitationModalOpen(true);
  };

  // const handleAfterDeleteProject = (id) => {
  //   console.log("Project Created", project);
  //   //update data to include new project
  //   let oldData = data;
  //   let newData = [...oldData, project];
  //   setData(newData);
  // };

  const handleCloseProjectClick = () => {
    setSelectedProject({});
    setSelectedProjectModalOpen(false);
  };

  // const showDeleteConfirm = (project) => {
  //   setShowDeleteConfirm(true);
  //   setSelectedProject(project);
  // };

  const handleCancelDeleteProjectClick = () => {
    // e.preventDefault();
    setSuccess(true);
    setDeletionEvent(null);
    setIdToDelete(null);
    setShowDeleteConfirm(false);
  };

  const handleDeleteProjectClick = (e, id) => {
    console.log("handleDeleteProjectClick", id);
    setShowDeleteConfirm(true);
    setDeletionEvent(e);
    setIdToDelete(id);
  };

  const showSolicitationDetails = (project, item) => {
    let projectId = project._id;
    let solicitationId = item._id;
    console.log("Opening solicitation details", item);
    history.push({
      // pathname: "projects/project-details/solicitation-details",
      pathname:
        "/projects/project-details/" +
        projectId +
        "/solicitation-details/" +
        solicitationId,
      state: { project: project, solicitation: item },
    });
  };

  const deleteProject = async (e) => {
    console.log("deleteProject", idToDelete);
    // setDeleteConfirmed(true);
    deletionEvent.preventDefault();
    console.log("Delete Project", idToDelete);
    const deleted = await Projects.delete(idToDelete);

    if (deleted) {
      //remove from data
      let oldData = data;
      let newData = oldData.filter((item) => item._id !== idToDelete);
      setData(newData);
      setSuccess(true);
      setDeletionEvent(null);
      setIdToDelete(null);
      setShowDeleteConfirm(false);
    }
  };

  // const showSolicitationDetails = (project, item) => {
  //   console.log("Opening solicitation details", item);
  //   history.push({
  //     pathname: "projects/project-details/solicitation-details",
  //     state: { project: project, solicitation: item },
  //   });
  // };

  return (
    // Page Container
    <div id="page_container" className="w-full max-w-14xl mx-auto h-full">
      {/* Header area */}
      {/* {!fromModal && (
        <div
          id="header_row"
          className="sm:flex sm:justify-between sm:items-center"
        >
          <div className="mb-0 sm:mb-0 inline-flex ">
            <PageHeader>Projects</PageHeader>
          </div>

          <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
            <Button
              color="secondary"
              handleClick={() => handleOpenNewProjectModalClick()}
              // shadow
            >
              <svg
                className="flex w-3 h-3 fill-current opacity-90 shrink-0"
                viewBox="0 0 16 16"
              >
                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
              </svg>
              <span className="inline-flex hidden xs:block ml-2">
                New Project
              </span>
            </Button>
          </div>
        </div>
      )} */}
      <div
        id="main_card"
        className={`${
          !fromModal ? "h-[calc(100vh-120px)] shadow-xl" : "h-full"
        } mt-4 bg-white rounded-sm border border-gray-200  w-full`}
      >
        {!fromModal && (
          <div id="card_header" className="px-6  ">
            <div className=" w-full flex items-center justify-between  ">
              <div>
                <header className=" py-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    Projects{" "}
                    <span className="text-md text-gray-400 font-medium">
                      {data && data.length}
                    </span>
                  </h2>
                </header>
              </div>
              <div></div>
            </div>
            <div className="border-b border-gray-200 flex items-center justify-between pb-4">
              <div className="flex items-center pb-2 whitespace-nowrap space-x-4">
                <Tabs
                  tabs={tabs}
                  setSelectedTab={setSelectedTab}
                  selectedTab={selectedTab}
                />
                <Input
                  placeholder="Search"
                  // Icon={
                  //   <svg
                  //     class="w-4 h-4 text-gray-500 mr-4"
                  //     aria-hidden="true"
                  //     xmlns="http://www.w3.org/2000/svg"
                  //     fill="none"
                  //     viewBox="0 0 20 20"
                  //   >
                  //     <path
                  //       stroke="currentColor"
                  //       stroke-linecap="round"
                  //       stroke-linejoin="round"
                  //       stroke-width="2"
                  //       d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                  //     />
                  //   </svg>
                  // }
                  iconPosition="left"
                  label="Search"
                  id="search"
                  indicator={
                    <svg
                      class="w-4 h-4 text-gray-500 "
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 25 25"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                      />
                    </svg>
                  }
                  type="text"
                  value={searchText}
                  errorText={null}
                  disabled={false}
                  autofill={false}
                  clearButton={searchText ? true : false}
                  handleClearAllSelections={() => {
                    setSearchText("");
                  }}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    // setFilterText(e.target.value);
                  }}
                />
                <div className="flex items-center space-x-2">
                  <Switch
                    id={"onlyShowMyData"}
                    checked={onlyShowMyData}
                    onChange={(e) => {
                      console.log("onlyShowMyData", e);
                      handleSetOnlyShowMyDate(e);
                    }}
                    className={classNames(
                      onlyShowMyData && onlyShowMyData === true
                        ? "bg-brand-600"
                        : "bg-gray-200",
                      "flex items-center w-8 cursor-pointer rounded-full p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600"
                    )}
                  >
                    <span
                      aria-hidden="true"
                      className={classNames(
                        onlyShowMyData && onlyShowMyData === true
                          ? "translate-x-3.5"
                          : "translate-x-0",
                        "flex h-4 w-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out"
                      )}
                    />
                  </Switch>
                  <label
                    htmlFor="onlyShowMyData"
                    className="flex items-center cursor-pointer mr-2 "
                  >
                    Only show my projects
                  </label>
                </div>
              </div>

              <div className="flex items-center space-x-8">
                {" "}
                <div
                  className="text-brand-500 text-sm font-semibold cursor-pointer"
                  onClick={handleChangeSortOrder}
                >
                  Sorted by:
                  {sortOrder == "recent" ? (
                    <span className="text-brand-500 text-sm font-semibold ml-2">
                      Recent
                    </span>
                  ) : (
                    <span className="text-brand-500 text-sm font-semibold ml-2">
                      A-Z
                    </span>
                  )}
                </div>
                <Button
                  color="secondary"
                  handleClick={() => handleOpenNewProjectModalClick()}
                  // shadow
                >
                  <svg
                    className="flex w-3 h-3 fill-current opacity-90 shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="inline-flex hidden xs:block ml-2">
                    New Project
                  </span>
                </Button>{" "}
              </div>
            </div>
          </div>
        )}

        <ListTable
          fromModal={fromModal}
          selectedRow={null}
          showDelete={false}
          setSelectedRow={null}
          dedupe={false}
          columns={[]}
          profile={null}
          competencies={[]}
          updatedId={null}
          updateMyData={null}
          setUpdatedId={null}
          skipReset={null}
          updateData={null}
          initialData={data} //this could also be unclaimedImpediments
          data={filteredData} //this could also be unclaimedImpediments
          page_size={10}
          size_limit={10}
          fetch_limit={10}
          loading={false}
          fromDashboard={false}
          showFooter={false}
          toggleValue={false}
          hasSubComponent={false}
          onToggleChange={(value) => {
            console.log("Toggle", value);
          }}
          navigateToProject={(item) => {
            fromModal
              ? props.handleOpenProjectClick(item)
              : navigateToProject(item);
          }}
          handleDeleteProjectClick={(e, item) =>
            handleDeleteProjectClick(e, item)
          }
        />
      </div>

      {/* {showDeleteConfirm && ( */}
      <DialogBox
        handleConfirmClick={deleteProject}
        handleCancelClick={handleCancelDeleteProjectClick}
        loading={false}
        success={success}
        open={showDeleteConfirm}
        title="Confirm Project Deletion"
        message={"Are you sure you want to delete this project?"}
        OKbuttonText={"Delete"}
        CancelButton={"Cancel"}
      />

      <ModalBasic
        id="assessment-modal"
        modalOpen={newProjectModalOpen}
        setModalOpen={setNewProjectModalOpen}
        title="Create a new project"
        showClose={false}
        showFooter={false}
        closeButtonText="Close"
        // size="lg"
        scrollable={true}
      >
        <div className="flex flex-col h-full items-center px-10 pt-3 pb-0">
          {newProjectModalOpen && (
            <NewProject
              setModalOpen={setNewProjectModalOpen}
              modalOpen={newProjectModalOpen}
              updateData={handleAfterCreateProject}
              step={newProjectStep}
              stepName={"Start"}
              fromModal={"projects"}
              handleCreateNewSolicitation={handleCreateNewSolicitation}
            />
          )}
        </div>
      </ModalBasic>
      <ModalBasic
        id="new-solicitation-model"
        modalOpen={newSolicitationModalOpen}
        setModalOpen={setNewSolicitationModalOpen}
        title="Create New Bid Request"
        showClose={false}
        showFooter={false}
        closeButtonText="Close"
        // size="lg"
        scrollable={true}
      >
        <div className="flex flex-col h-full items-center px-10 pt-3 pb-0">
          <NewSolicitation
            projectId={newSolicitationData?._id}
            project={newSolicitationData}
            setModalOpen={setNewSolicitationModalOpen}
            modalOpen={newSolicitationModalOpen}
            handleCloseButtonClick={(project, solicitation) =>
              showSolicitationDetails(project, solicitation)
            }
            updateData={null}
            stepOptions={4}
            step={0}
          />
        </div>
      </ModalBasic>
      <ModalBasic
        id="project-details-modal"
        modalOpen={selectedProjectModalOpen}
        setModalOpen={setSelectedProjectModalOpen}
        title="Create a new project"
        showClose={true}
        showFooter={false}
        closeButtonText="Close"
        size="lg"
        scrollable={true}
      >
        {/* <div className="flex items-center p-10"> */}
        <ProjectDetails project={selectedProject} />
        {/* </div> */}
      </ModalBasic>
    </div>
  );
}
